"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Progress_1 = __importDefault(require("./Progress"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var LEVELS = {
    1: 'one',
    2: 'two',
    3: 'three',
    4: 'four',
    5: 'five',
};
var CurrentLevel = function (_a) {
    var level = _a.level, currentLevelData = _a.currentLevelData, progressPercents = _a.progressPercents, userPoints = _a.userPoints, nextLevelMin = _a.nextLevelMin;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.level, " ").concat(styles_module_scss_1.default === null || styles_module_scss_1.default === void 0 ? void 0 : styles_module_scss_1.default[LEVELS[level.level]]) },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.status },
                react_1.default.createElement("p", null, "Your status:"),
                react_1.default.createElement("h2", null, currentLevelData.name)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.cashback },
                react_1.default.createElement("p", null, t('dailyCashBack')),
                react_1.default.createElement("h2", null,
                    currentLevelData.cashback.percent,
                    "%")),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.points },
                react_1.default.createElement("p", null,
                    t('points'),
                    ":"),
                react_1.default.createElement("h2", null, userPoints)),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.prizes },
                currentLevelData.maxBet && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        t('bonusMaxBet'),
                        ":"),
                    react_1.default.createElement("h2", null, currentLevelData.maxBet))),
                currentLevelData.reward && (react_1.default.createElement("div", null,
                    react_1.default.createElement("p", null,
                        t('instantReward'),
                        ":"),
                    react_1.default.createElement("h2", null, currentLevelData.reward)))),
            react_1.default.createElement("img", { src: currentLevelData.images.default, alt: "level" })),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.progress },
            react_1.default.createElement(Progress_1.default, { level: level.level, diffCount: 0, prevProgress: 0, progressPercents: progressPercents, currentExp: currentLevelData.fromPoints, totalExp: nextLevelMin, currentLevelData: currentLevelData }))));
};
exports.default = CurrentLevel;
